<template>
    <div class="hundred_percent_form" v-loading="loading">
        <tinymce
            style="display: inline-block;width: 100%;"
            ref="tinymce"
            :height="500"
            v-model="form.configstext"
        />
        <div style="margin-top:20px">
            <el-button type="primary" @click="formSubmit" :loading="formLoading" >保 存</el-button>
            <el-button @click="onCancel">取 消</el-button>
        </div>
    </div>
</template>

<script>
    import { userAgreement, edittreaty } from "../../api/setting/text.js";
    import Tinymce from "../../components/Tinymce/index.vue";
export default {
  components: {
      Tinymce
  },

  data() {
      return {
          loading: true,
          formLoading: false,
          form: {
              configsid:"",
              configstext: "",
              configstype: 3
          }
      };
  },

  methods: {
      onCancel() {
          this.getInfo();
      },
      getInfo() {
          this.loading = true;
          userAgreement({ configstype: this.form.configstype }).then(response => {
            if (response.code) {
                this.$message.error(response.message);
            }
            if (response.data) {
                this.form = response.data;
                this.$refs.tinymce.setContent(this.form.configstext);
            }
            setTimeout(() => {
                this.loading = false;
            }, 0.3 * 1000);
            });
      },
      formSubmit() {
          this.formLoading = true;
          let data = Object.assign({}, this.form);
          edittreaty(data).then(response => {
              this.formLoading = false;
              if (response.code) {
                  this.$message.error(response.message);
                  return false;
              }
              this.$message.success("操作成功");
              this.getInfo();
          });
      }
  },

  created() {
      this.getInfo();
  }
};
</script> 

<style type="text/scss" lang="scss">
    body {
        margin: 0;
    }
</style>